<template>
  <a
    :href="props.link.url"
    :target="props.link.target"
    class="link"
    :class="`${props.arrowDirection ?? ''} ${props.color ? '' + props.color : ''}
    ${props.reverse ? 'reverse' : ''}`">
    <p class="related-links-cta-content">{{ props.link.title }}</p>
    <div class="circle-link">
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.33398 14.1578H19.1513M25.9137 14.1402L21.4856 9.71205L19.2715 7.49799M25.9137 14.1402L19.2715 20.7824M25.9137 14.1402L19.1513 14.1578M17.0575 5.28394L19.2715 7.49799M17.0575 22.9964L19.2715 20.7824M19.2715 7.49799L22.4938 10.7436C23.7449 12.0038 22.8555 14.1481 21.0797 14.1527L19.1513 14.1578M19.2715 20.7824L22.4489 17.5562C23.6959 16.2902 22.7958 14.1481 21.0187 14.1528L19.1513 14.1578"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
  </a>
</template>

<script setup>
const props = defineProps(['link', 'color', 'arrowDirection', 'reverse'])
</script>

<style lang="scss">
.link {
  @apply relative mb-4 mt-4 flex min-h-[70px] w-fit overflow-hidden rounded-[60px] border border-bicara-dark-blue fill-bicara-blue py-4 pl-[30px] pr-[100px];

  .related-links-cta-content {
    @apply cta-1 m-0 self-center text-bicara-dark-blue transition-colors delay-75 duration-150;
  }

  &:before {
    @apply absolute right-0 top-0 -z-1 h-full w-0 origin-right rounded-xl bg-bicara-blue transition-all duration-300 content-[''];
  }

  .circle-link {
    @apply absolute -bottom-[1px] -right-[1px] -top-[1px] flex h-[70px] w-[70px] items-center justify-center overflow-hidden rounded-full border border-bicara-dark-blue p-4 text-bicara-white;

    &:before {
      @apply absolute bottom-0 left-0 right-0 top-0 -z-1 origin-center scale-75 rounded-full bg-bicara-blue transition-transform delay-300 duration-150 content-[''];
    }
  }

  &:hover {
    @apply transition-colors delay-150;

    &:before {
      @apply w-full scale-100 delay-100;
    }

    .circle-link {
      &:before {
        @apply scale-100 delay-0;
      }
    }
  }

  &.reverse {
    @apply pl-[100px] pr-[30px];

    &:before {
      @apply left-0 right-auto;
    }

    .circle-link {
      @apply -left-[1px] right-auto;
    }
  }

  &.white {
    @apply border-bicara-white fill-bicara-white;

    &:before {
      @apply bg-bicara-dark-blue;
    }

    .related-links-cta-content {
      @apply text-bicara-white;
    }

    .circle-link {
      @apply border-bicara-white text-bicara-white;

      &:before {
        @apply bg-bicara-dark-blue;
      }
    }
  }

  &.yellow {
    @apply fill-bicara-yellow;

    &:before {
      @apply bg-bicara-yellow;
    }

    .circle-link {
      @apply text-bicara-dark-blue;

      &:before {
        @apply bg-bicara-yellow;
      }
    }

    &:hover {
      @apply border-bicara-dark-blue;

      .circle-link {
        @apply border-bicara-dark-blue;
      }

      .related-links-cta-content {
        @apply text-bicara-dark-blue;
      }
    }
  }

  &.down {
    .circle-link {
      @apply rotate-90;
    }
  }

  &.up {
    .circle-link {
      @apply rotate-[270deg];
    }
  }

  &.left {
    .circle-link {
      @apply rotate-[180deg];
    }
  }
}
</style>
